<script>
  import { MediaItem, Pagination, Link } from '$client';
  import { page } from '$app/stores';
  import { onMount } from 'svelte';
  export let data;

  $: medias = data.medias.data;
  $: meta = data.medias.meta;
  $: mediaCenter = data.mediaCenter;

  const types = { news: 'Новости', blog: 'Блог', video: 'Видео' };
  $: type = $page.url.searchParams.get('type');
  const getCounters = () => {
    let columns = 4;
    const width = document.documentElement.clientWidth;
    if (width <= 1250) columns = 3;
    if (width <= 767.98) columns = 2;
    if (width <= 500.98) columns = 1;
    let rows = Math.ceil(medias.length / columns);
    return [columns, rows];
  };

  let [columns, rows] = [4, 4];
  onMount(() => ([columns, rows] = getCounters()));
</script>

<svelte:window on:resize={() => ([columns, rows] = getCounters())} />

<section id="main" class="container margin-block">
  <div>
    <h1 class="h1">{mediaCenter.header}</h1>
    <nav id="news-collections">
      <Link
        attributes={type ? {} : { class: 'active-collection', disabled: true }}
        href={$page.url.origin + $page.url.pathname}>Все</Link>
      {#each Object.entries(types) as [t, name]}
        <Link
          attributes={type === t ? { class: 'active-collection', disabled: true } : {}}
          href="/media-center?type={t}">{name}</Link>
      {/each}
    </nav>
  </div>
  <ul id="news" style={`--rows: ${rows}; --columns: ${columns};`}>
    {#each medias as media (media.id)}
      <li>
        <MediaItem type="media-center" data={media} />
      </li>
    {/each}
  </ul>
  <Pagination pages={meta.pagination.pageCount} />
</section>

<style lang="scss">
  #main {
    > div:first-child {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 40px;

      @media only screen and (max-width: 768.98px) {
        flex-direction: column;
      }

      h1 {
        font-weight: 800;
        font-family: Vela Sans;

        @media only screen and (max-width: 767.98px) {
          margin-bottom: 20px;
        }
      }
    }
  }

  #news {
    display: inline-grid;
    grid-auto-flow: dense;
    grid-gap: 40px;
    grid-template-rows: repeat(calc(var(--rows)), 1fr);
    grid-template-columns: repeat(var(--columns), 1fr);
    place-items: stretch stretch;
    width: 100%;

    @media only screen and (max-width: 1250px) {
      grid-gap: 20px;
    }

    @media only screen and (max-width: 550.98px) {
      grid-gap: 10px;
    }
  }

  #news-collections {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    justify-content: center;

    :global(a),
    :global(div) {
      padding: 8px 24px;
      color: #2c333c;
      font-weight: 500;
      font-size: 16px;
      font-family: Vela Sans;
      line-height: 140%;
      background: #f6f7f8;
      border-radius: 100px;
      transition:
        background 0.25s,
        color 0.25s;
    }

    :global(.active-collection) {
      color: #f6f7f8;
      background: #2c333c;
    }
  }
</style>
